import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { FormCertificateFilePickerProps } from './types';
import { mergeSelectedFiles } from './utils/merge-selected-files';
import { CertificateFilePicker } from '../../inputs/certificate-file-picker/certificate-file-picker';

export const FormCertificateFilePicker = <T extends FieldValues>({
  name,
  label,
  title,
  fileType,
  required = false,
}: FormCertificateFilePickerProps<T>) => {
  const { control } = useFormContext<T>();

  const acceptedFileType = Array.isArray(fileType) ? fileType.join(',') : fileType;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => (
        <CertificateFilePicker
          name={name}
          label={label}
          title={title}
          fileType={acceptedFileType}
          required={required}
          selectedFile={field.value}
          handleFileChange={(event) => {
            field.onChange(mergeSelectedFiles(event, field.value));
          }}
          clearSelectedFile={() => field.onChange(undefined)}
          error={errors[name]?.message as string}
        />
      )}
    />
  );
};
